import { LocationDescriptor } from "history";
import React from "react";
import { Route } from "react-router";

import { homepageUrl } from "@/mk2/apps/home/urls";
import { BackBtn } from "@/mk2/components/BackBtn";
import { BtnLayout, BtnType } from "@/mk2/components/Btn";
import { NotFoundError } from "@/mk2/components/errors/NotFoundError";
import { CTA_RETURN_BACK } from "@/mk/autogenerated/translation";

import styles from "./NotFound.mscss";

interface OwnProps {
    backUrl?: LocationDescriptor;
}

type Props = OwnProps;

export class NotFound extends React.Component<Props> {
    public render() {
        return (
            <Route
                render={({ staticContext }) => {
                    const { backUrl } = this.props;

                    if (staticContext && staticContext.statusCode === 200) {
                        // ak este nikto nenastavil http error status (napr. 403 - Forbidden z @authOnly,
                        // alebo 410 - Gone z render()) tak nastav 404 - Not Found
                        staticContext.statusCode = 404;
                    }

                    return (
                        <div className={styles.NotFound}>
                            <NotFoundError
                                button={
                                    <BackBtn
                                        label={CTA_RETURN_BACK}
                                        layout={BtnLayout.IconLabelCount}
                                        link={backUrl ? backUrl : homepageUrl}
                                        type={BtnType.Blue}
                                    />
                                }
                            />
                        </div>
                    );
                }}
            />
        );
    }
}
